import { useMediaQuery } from "react-responsive";

export default function Picture({ className, image, imageAlt, width }) {
  const isHighDPI = useMediaQuery({
    query: `only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (min-resolution: 120dpi)`,
  });

  const getSrc = () => {
    if (!width) {
      return image;
    }
    if (isHighDPI) {
      return `${image}?nf_resize=fit&w=${width * 2}`;
    }
    return `${image}?nf_resize=fit&w=${width}`;
  };
  return (
    <picture className={className}>
      <img alt={imageAlt} src={getSrc()} />
    </picture>
  );
}
